var hoverButtonOption="<div class='option-hover-logout'><button onclick=(window.location.href='/account/login') class='button-sign-in'>SIGN IN</button><button onclick=(window.location.href='/account/register') class='button-sign-up'>SIGN UP</button></div>"
class RedemptionDiscount {

	constructor(redeemptionOption){
		this.redeemptionOption=redeemptionOption;
	}

	renderRedemptionList()
	{
		this.redeemptionOption.forEach((option,index)=> {	
			if(option.discount_type === "fixed_amount"){		
			$(".swell-redemption-discount-options").append(
				$("<div>").addClass("option").append(
					$("<div>").addClass("option-text").append(
						$("<h4>").text(`${option.prettyDiscount} OFF =  ${option.amount} POINTS `)
					  ).addClass("swell-redemption-link").attr({
                            "data-redemption-option-id": option.id

                        }) 
                )
			)
		}

		})

	}
	renderRedemptionDiscountBakcgroundCssHover(customer) {
		if(customer.created_at===undefined){
    		$(".option").append(hoverButtonOption);
    	    $(".option").children(".option-hover-logout").hide();
    		$(".option").hover ( 
    	function() {
    		$(this).children(".option-text").children("h4").css("color","#0000005c" );
    	    $(this).children(".option-hover-logout").show();
    	},
    	function() {
    		$(this).children(".option-text").children("h4").css("color","black" );
    	     $(this).children(".option-hover-logout").hide();

    	})
	
    	}
	
}


}


